import useApi from "hooks/useApi";

// Permissoes do Modulo, retorna um objeto com as permissoes do modulo 
export default function apiUtils() {
    const api = useApi();
    return {
        GetModuleAcess(module, roleid){
            let response = api.get(`permissions/${module}/${roleid}`)
                .then((response) => {
                    if (response.status === 200) {
                        return response.data;
                    } else {
                        throw new Error("Erro ao obter as permissões do módulo.");
                    }
                })
                .catch((error) => {
                    console.error(error);
                    return null;
                });
            return response;
        }
    };
}